/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_Too_Many_RowsInputs */

const en_issue_too_many_rows = /** @type {(inputs: Issue_Too_Many_RowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`has more rows than an import can take`)
};

/**
* | output |
* | --- |
* | "has more rows than an import can take" |
*
* @param {Issue_Too_Many_RowsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_too_many_rows = /** @type {((inputs?: Issue_Too_Many_RowsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_Too_Many_RowsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_too_many_rows(inputs)
});